class KlevuSortBy extends HTMLElement {
  connectedCallback () {
    this.els = {
      select: this.querySelector('[data-klevu-sortby-el="select"]'),
      options: this.querySelectorAll('[data-klevu-sortby-el="option"]'),
    }

    this.setupListeners()
  }

  setupListeners () {
    this.els.select.addEventListener('change', this.handleSelectChange.bind(this))
  }

  handleSelectChange () {
    const selectedValue = this.els.select.value

    const correspondingDiv = Array.from(this.els.options).find(
      el => el.getAttribute('data-value') === selectedValue,
    )

    if (correspondingDiv) {
      correspondingDiv.click()
    }
  }
}

if (!customElements.get('klevu-sortby')) {
  customElements.define('klevu-sortby', KlevuSortBy)
}
